module.exports = __webpack_public_path__ + "static/media/generic_green_right_arrow.fe958d72.svg";